var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alerte-container",class:("alerte-" + _vm.type)},[_c('i',{staticClass:"fas fa-times fermer-icone",on:{"click":function($event){return _vm.fermer()}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }